import { clsx } from 'clsx';
import React from 'react';
import { ClassAttributes, TableHTMLAttributes } from 'react';
import styles from './Table.module.css';

export const Table = ({
  className,
  ...props
}: JSX.IntrinsicAttributes &
  ClassAttributes<HTMLTableElement> &
  TableHTMLAttributes<HTMLTableElement>) => (
  <table className={clsx(styles.table, className)} {...props} />
);
